// useTypedSelector.ts
// Date Created: 06-25-2020
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../../configureStore';

const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useTypedSelector;
